<div *ngIf="currentStep === 1" class="!mt-[-46px]">
  <div
    class="header h-[55px] flex justify-start items-center pl-[32px] mt-[30px] !bg-[#F1F3F5] sticky !z-20 top-0"
  >
    <p class="!m-0">{{ project_name }} - Initiate Expression Of Interest</p>
    <p
      class="!mt-[10px] bg-white !ml-[15px] flex items-center justify-center tag"
    >
      Project Brief
    </p>
  </div>
  <div class="px-[22px]">
    <app-brief-section></app-brief-section>
  </div>
  <div
    class="!pr-[32px] !mb-[60px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        (click)="nextStep()"
      >
        Next
      </button>
    </div>
  </div>
</div>
<div *ngIf="currentStep === 2">
  <app-work-packages-selection
    (responseEmitter)="getEoiDetailsFromWPComponent($event)"
    [currentEOISavedData]="currentEOISavedData"
  ></app-work-packages-selection>
</div>
<div *ngIf="currentStep === 3">
  <app-companies-selection
    (responseEmitter)="getEoiDetailsFromWPComponent($event)"
    [eoiId]="eoiId"
    [projectId]="projectId"
    [currentEOISavedData]="currentEOISavedData"
  ></app-companies-selection>
</div>
<div *ngIf="currentStep === 4">
  <app-submission-guidlines
    (responseEmitter)="getEoiDetailsFromWPComponent($event)"
    (closeModalEvent)="handleCloseModal($event)"
    [eoiId]="eoiId"
    [projectId]="projectId"
    [currentEOISavedData]="currentEOISavedData"
  ></app-submission-guidlines>
</div>
